import { initializeApp } from "firebase/app";
import { initializeAnalytics, type Analytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";

// Public client configuration only. This marketing client intentionally has
// no Auth, Firestore, Storage, billing, or administrative SDK surface.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBgNELMluU6lZeZp7nx_XkYBB2Ycu2dWoA",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "runmark.app",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "runmark-c8833",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "129858824564",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:129858824564:web:9aec4b4fe46e3fa1392421",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ?? "G-GHSL03E6BG",
};

const app = initializeApp(firebaseConfig);
export const functions = getFunctions(app);

let analyticsInstance: Analytics | null | undefined;

export function getAnalyticsInstance(): Analytics | null {
  if (analyticsInstance !== undefined) return analyticsInstance;
  if (
    process.env.NODE_ENV === "test" ||
    typeof window === "undefined" ||
    !firebaseConfig.measurementId ||
    navigator.webdriver === true
  ) {
    analyticsInstance = null;
    return analyticsInstance;
  }
  try {
    analyticsInstance = initializeAnalytics(app, { config: { send_page_view: false } });
  } catch (error) {
    console.warn("[analytics] Could not initialize Firebase Analytics", error);
    analyticsInstance = null;
  }
  return analyticsInstance;
}
